import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] grid place-items-center px-6">
      <div className="text-center">
        <div className="font-serif text-8xl gold-text">404</div>
        <h1 className="font-serif text-3xl mt-4">The stars could not find this page.</h1>
        <p className="text-foreground/70 mt-3">The path you seek does not exist.</p>
        <Link to="/"><Button className="mt-8 rounded-full bg-[#D4AF37] hover:bg-[#AD974F] text-[#0B1F3A] font-semibold">Back to Home</Button></Link>
      </div>
    </div>
  );
}
